
import { COST_CENTRE_METADATA } from './cost-centre.metadata';
import { CostCentreBase } from './cost-centre.model.base';
import { CrudEntity, CrudEntityConstructionOptions } from '@scisys-uim/uim-common';

export const COST_CENTRE_TYPE_WILDLIFE: string = 'W';

export interface CostCentre extends CostCentreBase {
}

export interface CostCentreTransient { }

export class CostCentre extends CrudEntity<CostCentre, string, CostCentreTransient> implements CostCentreTransient {
  constructor(source?: Partial<CostCentre>, options?: CrudEntityConstructionOptions<CostCentre, string, CostCentreTransient>) {
    super(COST_CENTRE_METADATA, source, options);
  }
  
  initialiseEntityDefaults() {
    super.initialiseEntityDefaults();
  }
  
  registerPropertyCalculators() {
    super.registerPropertyCalculators();
  }
}





